<template>
    <path
        d="M10.0438 1.27344H3.80833C2.31183 1.27344 1.18945 2.39581 1.18945 3.89232V16.7373C1.18945 18.2338 2.31183 19.3562 3.80833 19.3562H10.0438"
        fill="none"
        stroke-width="1.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path d="M15.5312 6.38281L19.3972 10.3735L15.5312 14.2395" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M19.3963 10.3828H9.29492" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
</template>
